import * as React from "react";
import { SVGProps, memo } from "react";

const NoAds = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    width="1em" height="1em" viewBox="0 0 63 41"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 9.855v21.956c0 5.042 3.881 9.148 8.648 9.148h44.97c4.766 0 8.648-4.106 8.648-9.149V9.856c0-5.043-3.882-9.148-8.648-9.148H8.648C3.878.707 0 4.812 0 9.855Zm53.614-5.49c2.862 0 5.19 2.463 5.19 5.49v21.956c0 3.026-2.328 5.49-5.19 5.49H8.648c-2.861 0-5.19-2.464-5.19-5.49V9.855c0-3.027 2.329-5.49 5.19-5.49h44.966Z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.844 23.228c-.219-2.3-2.522-2.922-4.52-3.462-1.703-.46-3.185-.86-2.96-2.192.392-1.899 3.533-1.497 4.916-.639 1.122.804 2.468-.785 1.197-1.79-2.58-1.935-8.058-1.296-8.488 2.247-.228 2.04.838 3.026 2.229 3.636l7.626 2.2Zm-11.91-3.436c-.457-2.72-2.524-5.14-6.261-5.14h-4.281c-.617 0-1.29.476-1.29 1.133v.593l2.468.712v-.21h3.103c1.748 0 2.892.9 3.456 2.103l2.805.809Zm-2.409 1.529 2.428.7c-.415 2.773-2.474 5.268-6.112 5.268h-4.45c-.616 0-1.289-.33-1.289-1.133v-7.554l2.468.712v5.747h3.103c2.38 0 3.687-1.818 3.852-3.74ZM16.52 15.837l3.388.978 4.488 8.72c.766 1.425-1.496 2.557-2.169 1.133l-.822-1.607h-6.899l-.803 1.607c-.3.62-.991.748-1.664.62-.598-.328-.972-.985-.598-1.752l5.08-9.699Zm30.526 8.808 2.42.698c-1.512 2.994-6.964 2.834-9.196 1.033-.617-.493-.598-1.297-.262-1.79.486-.475 1.028-.639 1.664-.128 1.29.861 4.29 1.541 5.374.187Zm-31.38-1.994 2.299-4.51 2.112 4.51h-4.412Z"
      fill="#000"
    />
    <path
      d="m17.122 13.787 33.581 9.835"
      stroke="#000"
      strokeWidth={1.069}
      strokeLinecap="round"
    />
    <path d="M10.396 13.152 54.4 25.174" stroke="#000" strokeWidth={3.206} />
  </svg>
);

const MemoNoAds = memo(NoAds);
export default MemoNoAds;
